(function () {
  function setBuyNowError(btn, message) {
    const targetSelector = btn.dataset.errorTarget;
    if (!targetSelector) return;
    const target = document.querySelector(targetSelector);
    if (!target) return;
    target.textContent = message || '';
    target.toggleAttribute('hidden', !message);
  }

  function bindBuyNow() {
    document.querySelectorAll('[data-r3nu-buy-now]').forEach((btn) => {
      if (btn.dataset.r3nuBound === 'true') return;
      btn.dataset.r3nuBound = 'true';
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        const formId = btn.dataset.formId;
        const form = formId ? document.getElementById(formId) : null;
        if (!form || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;

        setBuyNowError(btn, '');

        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('loading');

        const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: {} };
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = new FormData(form);

        try {
          const url = window.routes?.cart_add_url || '/cart/add';
          const res = await fetch(url, config);
          const response = await res.json();
          if (response.status) {
            const msg = response.description || response.message || '';
            if (msg) setBuyNowError(btn, msg);
            return;
          }
          window.location.href = '/checkout';
        } catch (err) {
          console.error(err);
          setBuyNowError(btn, 'Unable to continue to checkout. Please try again.');
        } finally {
          btn.disabled = false;
          btn.removeAttribute('aria-disabled');
          btn.classList.remove('loading');
        }
      });
    });
  }

  window.r3nuBindBuyNow = bindBuyNow;

  document.addEventListener('DOMContentLoaded', bindBuyNow);
  document.addEventListener('shopify:section:load', bindBuyNow);
})();
